<template>
  <v-container fluid class="specialization">
    <v-card>
      <v-card-text><h3>Specialization</h3></v-card-text>
    </v-card>
    <v-card flat class="mt-3">
      <v-card-title> <p>My Area(s) Of Specialization</p> </v-card-title>
      <v-card-text>
        <div class="chip--border d-flex">
          <v-chip-group column class="align-self-start">
            <v-chip
              v-for="(item, i) in formData.specializations"
              :key="i"
              large
              outlined
              color="primary"
            >
              {{ item.code }}
              <v-divider vertical class="mx-3" inset />
              {{ item.description }}
              <v-btn
                @click="deleteSpecs(item)"
                color="error"
                elevation="0"
                class="ml-3"
                icon
                large
              >
                <v-icon class="mx-2">close</v-icon>
              </v-btn>
            </v-chip>
          </v-chip-group>
          <v-btn
            :disabled="formData.specializations.length === 0"
            class="align-self-end mb-4 ml-10"
            color="primary"
            @click="submitSpecs"
          >
            <v-icon class="mx-2">save</v-icon>
            save
          </v-btn>
        </div>
        <div class="mt-3">
          <div><p>Select To Add Specialization</p></div>
          <v-chip-group column>
            <v-chip large v-for="(item, i) in types" :key="i" label>
              {{ item.code }}
              <v-divider vertical class="mx-3" inset />
              {{ item.description }}
              <v-btn
                color="primary"
                elevation="0"
                @click="addSpecs(item)"
                class="ml-3"
              >
                <v-icon class="mx-2">add</v-icon>
                Add
              </v-btn>
            </v-chip>
          </v-chip-group>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between">
        <v-btn
          class="mx-2 contacts--button"
          color="error"
          text
          @click="$router.back()"
        >
          <v-icon class="mx-2"> arrow_back </v-icon>
          Back
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import AuthService from "../../../dashboard/modules/auth/AuthService";
export default {
  name: "SpecializationComponent",
  data: function () {
    return {
      formData: {
        specializations: [],
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.formData.specializations = v.specializations;
      window.document.title = "KISEB::Specializations Profile";
    });
  },
  computed: {
    specializations() {
      return this.$store.getters["Profile/specializationGetters"](
        "specializations",
      );
    },
    types() {
      return this.$store.getters["Profile/setupGetter"]("types");
    },
  },
  watch: {
    specializations() {
      this.formData.specializations = [...this.specializations];
    },
  },
  methods: {
    addSpecs(item) {
      if (this.formData.specializations.indexOf(item) === -1) {
        this.formData.specializations.push(item);
      }
    },
    deleteSpecs(item) {
      this.formData.specializations.splice(
        this.formData.specializations.indexOf(item),
        1,
      );
    },
    submitSpecs() {
      //check for delete specs
      const deleteSpecializations = this.specializations.filter((item) => {
        return this.formData.specializations.indexOf(item) === -1;
      });
      //check new specs
      const addSpecializations = this.formData.specializations
        .filter((item) => item.lineNo === undefined)
        .map((spec) => {
          spec.profileID = AuthService.user.profile_id;
          return spec;
        });
      this.$store.dispatch("Profile/submitspecialization", {
        deleteSpecializations,
        addSpecializations,
      });
    },
  },
};
</script>
<style>
@import url("./styles.css");
</style>
